<template>
  <div
    :class="[
      {
        must: fieldObj.required == 1,
        err: fieldObj.dirty && fieldObj.invalid
      },
      fieldStyle
    ]"
  >
    <div class="m-input-content">
      <div v-if="fieldStyle == 'style1'" class="u-label">
        {{ fieldObj.displayName }}
      </div>
      <div
        v-if="fieldStyle == 'style2' && !fieldObj.value.length"
        class="opacityText opacity-selsect mr28"
      >
        {{ fieldObj.displayName }}
      </div>
      <div
        class="m-select"
        :class="[
          {
            'select-temp': fieldObj.value.length
          }
        ]"
      >
        <a-select
          class="status-select"
          mode="multiple"
          :allowClear="true"
          :showArrow="true"
          :placeholder="fieldStyle == 'style1' ? '请选择' : ''"
          v-model="fieldObj.value"
          @change="handleChange"
          @focus="handleFocus"
          @blur="handleBlur"
          :disabled="fieldObj.disabled"
        >
          <div slot="suffixIcon">
            <a-icon
              type="down"
              :class="{ 'rotate90-r': moved && fieldStyle == 'style2' }"
            />
          </div>
          <a-select-option
            v-for="o in fieldObj.listOptions"
            :key="o.optionId"
            :value="o.optionValue"
          >
            {{ o.optionLabel || o.optionValue }}
          </a-select-option>
        </a-select>
        <div
          v-if="fieldStyle == 'style2'"
          class="u-label select-label mr28"
          :class="{
            'select-m-moved': moved || fieldObj.value.length
          }"
        >
          {{ fieldObj.displayName }}
        </div>
      </div>
    </div>

    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import checkboxSelectMixin from "../../field/new-fields/checkbox-select";
export default {
  name: "sk-checkbox-select",
  mixins: [checkboxSelectMixin]
};
</script>
